module.exports = __webpack_public_path__ + "static/media/vitalMobile2.61b9d427.svg";